import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import main from '../views/Dashboard.vue';
import SitesView from '../views/SitesView.vue';
import PlantsView from '../views/PlantManager.vue';
import DepartmentsView from '../views/DepartmentsView.vue';
import LocationsView from '../views/LocationsView.vue';
import AssetsView from '../views/AssetsView.vue';
import EmployeesView from '../views/EmployeesView.vue';
import AssetCategoryView from '../views/AssetCategoryView.vue';
import SafetyView from '../views/SafetyView.vue';
import FailureCodeView from '../views/FailureCodeView.vue';
import SafetyInstructionView from '../views/SafetyInstructionView.vue';
import SuppliersView from '../views/SuppliersView.vue';
import AssetsBySiteReport from '../views/reports/AssetsBySiteReport.vue';
import AssetsByLocationReport from '../views/reports/AssetsByLocationReport.vue';
import AssetsByDepartmentReport from '../views/reports/AssetsByDepartmentReport.vue';
import AssetsByCategoryReport from '../views/reports/AssetsByCategoryReport.vue';
import WorkOrdersView from '../views/WorkOrdersView.vue';
import WorkorderListView from '../views/WorkorderListView.vue';
import CreatePmView from '../views/CreatePmView.vue';
import PmListView from '../views/PmListView.vue';
import Dashboard from '../views/Dashboard.vue'
import OpenWorkOrdersReport from '@/views/reports/OpenWorkOrdersReport.vue';
import ClosedWorkOrdersReport from '@/views/reports/ClosedWorkOrdersReport.vue';
import WorkOrdersByAsset from '@/views/reports/WorkOrdersByAsset.vue'
import AssetBreakdownAnalysis from '@/views/reports/AssetBreakdownAnalysis.vue';

// Import the new components for authentication and control panel
import Login from '../views/Login.vue';
import ControlPanel from '../views/ControlPanel.vue';
import AdminPanel from '../views/AdminPanel.vue';
import Unauthorized from '../views/Unauthorized.vue';
import AboutView from '@/views/AboutView.vue';

const routes = [
  // Authentication Routes
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresGuest: true }
  },
  {
    path: '/about',
    name: 'About',
    component: AboutView,
     meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager', 'user'] 
     }
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: Unauthorized
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue'),
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager', 'user'] 
    }
  },

  // Main Dashboard Route - للجميع
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager', 'user'] 
    }
  },

  // Control Panel Routes - للإدارة والمديرين
  {
    path: '/control-panel',
    name: 'ControlPanel',
    component: ControlPanel,
    meta: { 
      requiresAuth: true, 
      allowedRoles: ['super_admin', 'admin', 'manager'],
    }
  },

  // Admin Panel - للسوبر أدمن والأدمن فقط
  // {
  //   path: '/admin',
  //   name: 'Admin',
  //   component: AdminPanel,
  //   meta: { 
  //     requiresAuth: true, 
  //     allowedRoles: ['super_admin', 'admin'],
  //     requiresPermission: 'admin_access'
  //   }
  // },

  // Management Routes - للمديرين والإدارة
  {
    path: '/site',
    name: 'site',
    component: SitesView,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager'] 
    }
  },
  {
    path: '/department',
    name: 'department',
    component: DepartmentsView,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager'] 
    }
  },
  {
    path: '/plant',
    name: 'plant',
    component: PlantsView,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager'] 
    }
  },
  {
    path: '/location',
    name: 'location',
    component: LocationsView,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager'] 
    }
  },
  {
    path: '/assets',
    name: 'asset',
    component: AssetsView,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager'] 
    }
  },
  {
    path: '/employees',
    name: 'employees',
    component: EmployeesView,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager'] 
    }
  },
  {
    path: '/assetcategory',
    name: 'assetcategory',
    component: AssetCategoryView,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager'] 
    }
  },
  {
    path: '/safety',
    name: 'safety',
    component: SafetyView,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager'] 
    }
  },
  {
    path: '/failurecode',
    name: 'failurecode',
    component: FailureCodeView,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager'] 
    }
  },
  {
    path: '/safetyinstructions',
    name: 'safetyinstructions',
    component: SafetyInstructionView,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager'] 
    }
  },
  {
    path: '/suppliers',
    name: 'suppliers',
    component: SuppliersView,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager'] 
    }
  },

  // Work Orders - للجميع
  // {
  //   path: '/workorders',
  //   name: 'workorders',
  //   component: WorkOrdersView,
  //   meta: { 
  //     requiresAuth: true,
  //     allowedRoles: ['super_admin', 'admin', 'manager', 'user'] 
  //   }
  // },
  // {
  //   path: '/workorderslist',
  //   name: 'workorderslist',
  //   component: WorkorderListView,
  //   meta: { 
  //     requiresAuth: true,
  //     allowedRoles: ['super_admin', 'admin', 'manager', 'user'] 
  //   }
  // },
  // {
  //   path: '/create-pm/:pmTaskNo?',
  //   name: 'create-pm',
  //   component: () => import('../views/CreatePmView.vue'),
  //   meta: { 
  //     requiresAuth: true,
  //     allowedRoles: ['super_admin', 'admin', 'manager'] 
  //   }
  // },
  // {
  //   path: '/pm-list',
  //   name: 'pm-list',
  //   component: () => import('../views/PmListView.vue'),
  //   meta: { 
  //     requiresAuth: true,
  //     allowedRoles: ['super_admin', 'admin', 'manager'] 
  //   }
  // },

  // Reports Routes - للمديرين والإدارة فقط
  {
    path: '/reports/assets-by-site',
    name: 'AssetsBySiteReport',
    component: AssetsBySiteReport,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager'] 
    }
  },
  {
    path: '/reports/assets-by-location',
    name: 'AssetsByLocationReport',
    component: AssetsByLocationReport,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager'] 
    }
  },
  {
    path: '/workorders-by-asset',
    name: 'WorkOrdersByAsset',
    component: WorkOrdersByAsset,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager'] 
    }
  },
  {
    path: '/asset-breakdown-analysis',
    name: 'AssetBreakdownAnalysis',
    component: AssetBreakdownAnalysis,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager'] 
    }
  },
  {
    path: '/reports/openwo',
    name: 'OpenWorkOrdersReport',
    component: OpenWorkOrdersReport,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager'] 
    }
  },
  {
    path: '/reports/closedwo',
    name: 'ClosedWorkOrdersReport',
    component: ClosedWorkOrdersReport,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager'] 
    }
  },
  {
    path: '/reports/assets-by-department',
    name: 'AssetsByDepartmentReport',
    component: AssetsByDepartmentReport,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager'] 
    }
  },
  {
    path: '/reports/assets-by-category',
    name: 'AssetsByCategoryReport',
    component: AssetsByCategoryReport,
    meta: { 
      requiresAuth: true,
      allowedRoles: ['super_admin', 'admin', 'manager'] 
    }
  },

  // Redirect all unknown routes to dashboard
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// Advanced Route Guard مع الصلاحيات
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const userRoles = user?.roles || [];
  const userPermissions = user?.permissions || [];

  console.log('🛡️ Route guard - to:', to.name, 'User roles:', userRoles);

  // إذا كان الطريق يتطلب تسجيل دخول ولم يكن المستخدم مسجلاً
  if (to.meta.requiresAuth && !isAuthenticated) {
    console.log('🔒 Redirecting to login');
    next('/login');
    return;
  }

  // إذا كان المستخدم مسجلاً وحاول الدخول على login
  if (to.name === 'Login' && isAuthenticated) {
    console.log('🔀 Redirecting to dashboard (already authenticated)');
    next('/');
    return;
  }

  // إذا كان الطريق للضيوف فقط والمستخدم مسجل
  if (to.meta.requiresGuest && isAuthenticated) {
    console.log('🔀 Redirecting to dashboard (guest route)');
    next('/');
    return;
  }

  // التحقق من الأدوار المطلوبة
  if (to.meta.allowedRoles) {
    const hasAllowedRole = to.meta.allowedRoles.some(role => 
      userRoles.includes(role)
    );
    
    if (!hasAllowedRole) {
      console.log('🚫 Insufficient role for:', to.name);
      console.log('❌ User roles:', userRoles, 'Required:', to.meta.allowedRoles);
      next('/unauthorized');
      return;
    }
  }

  // التحقق من الصلاحيات المطلوبة
  if (to.meta.requiresPermission) {
    const hasPermission = userPermissions.includes(to.meta.requiresPermission);
    
    if (!hasPermission) {
      console.log('🚫 Insufficient permission for:', to.name);
      console.log('❌ User permissions:', userPermissions, 'Required:', to.meta.requiresPermission);
      next('/unauthorized');
      return;
    }
  }

  console.log('✅ Allowing navigation to:', to.name);
  next();
});

export default router;